import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/common/modules/data-table.module/interfaces';
import { ApiResponse } from 'src/app/core/entities/api-response.entity/api-response';
import { ApiService } from 'src/app/core/services/api.service/api.service';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { User } from 'src/app/entities/user.entity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssistancePatientsService extends ApiService {
  search(searchQuery: { birthDay?: Date | undefined; query: string; }, pageRequest: PageRequest) {
    let params = new HttpParams();
    if (searchQuery.birthDay) params = params.append('birthdate', searchQuery.birthDay.getTime());
    if (searchQuery.query.length != 0) params = params.set('q', searchQuery.query);
    if (pageRequest!.pageOffset) params = params.append('page', pageRequest!.pageOffset)
    if (pageRequest!.pageSize) params = params.append('size', pageRequest!.pageSize);
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients/search`, { params: params, responseType: 'json' }).pipe(this.responsePipe)
  }

  all(pageRequest?: PageRequest): Observable<any> {
    if (pageRequest) {
      let params = new HttpParams();
      if (pageRequest!.pageOffset) params = params.append('page', pageRequest!.pageOffset)
      if (pageRequest!.pageSize) params = params.append('size', pageRequest!.pageSize);
      return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients`, { params: params }).pipe(this.responsePipe)
    } else
      return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients/all`).pipe(this.responsePipe)
  }

  one(id: string): Observable<any> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients/${id}`, { responseType: 'json' }).pipe(this.responsePipe);
  }

  add(data: FormData, accompanistUserName?: string): Observable<DoctorPatient> {
    return this.http.post<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients${accompanistUserName ? '?accompanistUserName=' + accompanistUserName : ''}`, data, { responseType: 'json' }).pipe(this.responsePipe);
  }

  update(id: string, data: FormData): Observable<DoctorPatient> {
    return this.http.put<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients/${id}`, data, { responseType: 'json' }).pipe(this.responsePipe);
  }

  delete(doctorPatient: string): Observable<DoctorPatient> {
    return this.http.delete<ApiResponse>(`${environment.API_URL}/doctor/Assistance/patients/${doctorPatient}`, { responseType: 'json' }).pipe(this.responsePipe);
  }
}
